import {mapActions, mapState} from 'vuex';
export default {
    computed:{
        ...mapState({
            home: state => state.auth.home
        }),
    },
    methods:{
        onReturn(){
            this.$router.replace(this.home);
        },
        ...mapActions({
            logout: 'auth/logout',
        }),
    }
}
